import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import RoutesUtils from '../../utils/routes';
import Utils from '../../utils/index';
import { DriveItemListOrigin } from '../DriveItemListPage/constants';
import DownloadManagerUtils from '../../utils/downloadManager';
import AuthUtils from '../../utils/authentication';
import StaticPage from '../../components/StaticPage';
import { GalleryInfosState } from '../Gallery/reducer';
import { DriveListState } from '../DriveItemList/reducer';
import { Api } from '../../typings/api';
import { AuthenticationState } from '../Authentication/reducer';
import { AppInfosState } from '../App/reducer';
import { DownloadManagerState } from '../DownloadManager/reducer';

const hasNoWelcomePage = (component: string | undefined, template: Api.Template) => {
	const isWelcomePagePath = !component;
	const welcomePage = template && template.welcomepage;
	return isWelcomePagePath && (!welcomePage || !welcomePage.url);
};

const isStaticPageAvailable = (
	galleryInfos: GalleryInfosState, driveList: DriveListState, authentication: AuthenticationState,
	appInfos: AppInfosState, component: string | undefined
): boolean => {
	const { template, isConfigLoaded } = galleryInfos;
	const { needCredentials, mode } = authentication.userInfos;
	const isTemplateLoaded = Utils.isTemplateLoaded(appInfos, galleryInfos);
	const needConnection = needCredentials && AuthUtils.isNotConnected(mode) && !isTemplateLoaded;
	const isComponentAvailable = !component || (component && driveList.driveItems[component]) ? true : false;
	const isMenuLoaded = template && template.menu ? true : false;

	return isConfigLoaded && isTemplateLoaded && isMenuLoaded && isComponentAvailable && !needConnection;
};

const resolveComponentId = (component: string | undefined, galleryInfos: GalleryInfosState, driveList: DriveListState): number => {
	const { welcomepage } = galleryInfos.template;

	if (!component && welcomepage) {
		return Utils.getMediaId(welcomepage.url);
	} else if (component && driveList.driveItems[component]) {
		return parseInt(component, 10);
	} else {
		RoutesUtils.getPageNotFound();
		return 0;
	}
};

const getIframeUrl = (galleryInfos: GalleryInfosState, downloadManager: DownloadManagerState, driveList: DriveListState, component: string | undefined): string => {
	const isWelcomePagePath = !component;
	const componentId = resolveComponentId(component, galleryInfos, driveList);
	const isAvailableOffline = DownloadManagerUtils.isItemDownloaded(downloadManager, componentId);
	const componentUrl = Utils.getComponentUrl(galleryInfos, componentId, isAvailableOffline, isWelcomePagePath);

	return componentUrl;
};

const mapStateToProps = (state: StoreState) => {
	const { appInfos, galleryInfos, routerParamsHistory, downloadManager, driveList, authentication } = state;
	const { component } = RoutesUtils.getCurrentRouterParam(routerParamsHistory).params;
	const { template } = galleryInfos;

	if (hasNoWelcomePage(component, template)) {
		return RoutesUtils.historyPush(RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, null));
	}

	const isStaticPage = isStaticPageAvailable(galleryInfos, driveList, authentication, appInfos, component);
	const iframeUrl = isStaticPage ? getIframeUrl(galleryInfos, downloadManager, driveList, component) : '';
	return { downloadManager, driveList, iframeUrl };
};

export default connect(mapStateToProps)(StaticPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/StaticPage/index.tsx